import { PosBillingScreen } from './PosBillingScreen';

export function PosPage() {
  return <PosBillingScreen />;
}
